import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { getCCMenu } from 'app-webtech-core/modules/player/actions/helpers/ccMenuIndexHelper';
import { playerPropertiesSelector } from '../selectors/properties';
import { CC_NEXT_SUBMENU } from './types';

// The payload schema to make sure that the payload has the correct information
const payloadSchema = Joi.object().keys({
  currentCCMenu: Joi.array().required(),
  currentCCMenuName: Joi.string().required(),
  ccMenuSelectedIndexes: Joi.array().required(),
});

// Creates the action with the action type and the payload schema
const playerCCNextSubmenuAction = actionCreator(CC_NEXT_SUBMENU, payloadSchema);

// Does the calculations and make sure the to grab the correct submenu
// Payload is the showReset variable
export const playerCCNextSubmenuThunkAction = (payload) => async (dispatch, getState) => {
  const state = getState();

  const {
    ccMenuSelectedIndexes: menuIndexes,
    currentCCMenu: currMenu,
    currentCCMenuName: currName,
  } = playerPropertiesSelector(state);

  // increases the index array to 1 to say that it's advanced to another menu
  const newIndex = menuIndexes.concat(0);

  // get the menu object with helper function
  const menuObj = getCCMenu(newIndex, currMenu, currName, payload);

  // if the menu stops at a setting do not dispatch event to change the state from prior
  if (menuObj.settingName === '' && menuObj.settingValue === '') {
    const newMenuItems = {
      currentCCMenu: menuObj.currentCCMenu,
      currentCCMenuName: menuObj.currentCCMenuName,
      ccMenuSelectedIndexes: newIndex,
    };
    dispatch(playerCCNextSubmenuAction(newMenuItems));
  }
};
